import { render, staticRenderFns } from "./my-uploadOnly.vue?vue&type=template&id=41cc5bc7&scoped=true"
import script from "./my-uploadOnly.vue?vue&type=script&lang=js"
export * from "./my-uploadOnly.vue?vue&type=script&lang=js"
import style0 from "./my-uploadOnly.vue?vue&type=style&index=0&id=41cc5bc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cc5bc7",
  null
  
)

export default component.exports